module.exports = __webpack_public_path__ + "static/media/SostenibilitàSistemica_ASSETS-Fish_23.a003fdc8.png";